"use client";

import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/navigation";
import UserService from "@/services/api/UserService";
import CommonImage from "../../image/CommonImage";
import { FaBell } from "react-icons/fa";
import { toast } from "react-toastify";
import { fetchUserInfo } from "@/redux/slices/userSlice";

export default function StudentNotifications() {
  const userInfo = useSelector((state) => state.user.userInfo);
  const router = useRouter();
  const wrapperRef = useRef(null);
  const listRef = useRef(null);
 const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (isOpen && notifications.length === 0) {
      fetchNotifications(1);
    }
  }, [isOpen]);

  useEffect(() => {
    const handleScroll = () => {
      if (!listRef.current || loading || !hasMore) return;

      const { scrollTop, scrollHeight, clientHeight } = listRef.current;
      if (scrollTop + clientHeight >= scrollHeight - 50) {
        fetchNotifications(page + 1);
      }
    };

    const listEl = listRef.current;
    if (listEl) listEl.addEventListener("scroll", handleScroll);
    return () => listEl && listEl.removeEventListener("scroll", handleScroll);
  }, [page, loading, hasMore]);

  const fetchNotifications = async (nextPage) => {
    if (loading) return;
    setLoading(true);
    try {
      const res = await UserService.getNotifications({ page: nextPage });
      if (res?.data?.length) {
        setNotifications((prev) =>
          nextPage === 1 ? res.data : [...prev, ...res.data]
        );
        setPage(nextPage);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Notification fetch failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleNotificationClick = async (item) => {
    try {
      await UserService.markNotificationAsRead(item.id);

      setNotifications((prev) =>
        prev.map((n) => (n.id === item.id ? { ...n, is_seen: true } : n))
      );

      setIsOpen(false);

      const type = item?.notification?.notification_for;
      switch (type) {
        case "Exam":
        case "Class":
        case "Admission":
          router.push("/student/my-courses");
          break;
        case "Payment":
          router.push("/student/payment-history");
          break;
        case "Notice":
          router.push("/notice");
          break;
        case "Result":
          router.push("/student/result");
          break;
        default:
          console.log("Unknown notification type:", type);
      }
    } catch (error) {
      console.error("Failed to mark as read:", error);
    }
  };

  const handleAllNotificationClear = async (item) => {
    try {
      await UserService.markAllNotificationAsRead();
      fetchNotifications(1);
      dispatch(fetchUserInfo());    
      toast.success("Clear All Notification");
    } catch (error) {
      console.error("Failed to mark as read:", error);
    }
  };

  return (
    <div ref={wrapperRef} className="relative flex items-center">
      <button
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
        className="notification cursor-pointer"
      >
        <CommonImage
          src={"/images/dashboard-images/bell-icon.avif"}
          className="notification-icon flex items-center"
          alt={"notification"}
        />
        <span className="total-notification">
          {userInfo?.notifications ?? 0}
        </span>
      </button>

      {isOpen && (
        <div
          ref={listRef}
          className="notification-dropdown-menu"
          style={{ maxHeight: 300, overflowY: "auto" }}
        >
          <div className="notification-header">
            <h4 className="title">নোটিফিকেশনস</h4>
            <button
              className="all_read"
              onClick={() => handleAllNotificationClear()}
            >
              সবকিছু রিড করুন
            </button>
          </div>
          {notifications.length > 0 ? (
            notifications.map((item,index) => (
              <div
                key={index}
                onClick={(e) => {
                  e.stopPropagation();
                  handleNotificationClick(item);
                }}
                className={
                  item.is_seen
                    ? "single-notification-read"
                    : "single-notification-unread"
                }
                style={{ cursor: "pointer" }}
              >
                <div className="empty">
                  <div className="notification-icon-wrap">
                    <FaBell className="notification-icon" />
                  </div>
                </div>
                <div className="noticication-text">
                  <p className="text">{item?.message}</p>
                  <p className="date">{item?.date}</p>
                </div>
                {!item.is_seen && (
                  <div className="unread-icon">
                    <span className="icon"></span>
                  </div>
                )}
              </div>
            ))
          ) : (
            <div style={{ padding: 20, textAlign: "center", color: "gray" }}>
              কোনো নোটিফিকেশন পাওয়া যায়নি
            </div>
          )}

          {loading && (
            <div
              style={{ padding: 10, textAlign: "center" }}
              className="text-dark-blue-text"
            >
              লোড হচ্ছে...
            </div>
          )}
        </div>
      )}
    </div>
  );
}
